import { Events } from 'global/constants';
import { storeUpdated } from './inkTonerDropdownUtility';

const { OdSelect } = window.od;

export default class InkTonerDropdownObserver {
	constructor(
		containerElement,
		assistedSearchIndex,
		dropdownElementReference,
		dropdownIndex,
	) {
		this.containerElement = containerElement;
		this.assistedSearchIndex = assistedSearchIndex;
		this.dropdownElementReference = dropdownElementReference;
		this.dropdownIndex = dropdownIndex;
		this.newOptionList = [];

		this.init(dropdownElementReference);
	}

	init(dropdownElementReference) {
		this.element = this.containerElement.querySelector(
			`[data-assistedsearch-field="${dropdownElementReference}"]`,
		);

		if (this.element) {
			this.selectChoice = new OdSelect(this.element, {
				searchPlaceholderValue: this.element.dataset.placeholder,
				noResultsText: this.element.dataset.noresults,
			});
			this.selectChoice.addEventListener(
				Events.CHOICES_CHOICE,
				this.optionPicked.bind(this),
			);
			window.od.events.subscribe(
				Events.INKTONER_STORE_CREATED,
				this.storeUpdated.bind(this),
			);
			window.od.events.subscribe(
				Events.INKTONER_STORE_CHANGED,
				this.storeUpdated.bind(this),
			);
		}
	}

	storeUpdated(event) {
		if (event.assistedSearchIndex === this.assistedSearchIndex) {
			this.makeInactive();
			storeUpdated(
				event,
				this.dropdownElementReference,
				this.updateDropdown.bind(this), // callback to be called if dropdown data has changed
			);
		}
	}

	updateDropdown(newOptionList) {
		if (!newOptionList) {
			this.resetOptions();
			this.disableDropdown();
		} else if (this.testForSelected(newOptionList)) {
			this.applyChoices(newOptionList);
		} else {
			this.handleActiveState(newOptionList);
			this.resetOptions();
			this.applyChoices(newOptionList);
			this.enableDropdown();
			this.newOptionList = newOptionList;
		}
	}

	testForSelected(newOptionList) {
		return newOptionList.find(option => option.selected === true);
	}

	handleActiveState(newOptionList) {
		if (this.dropdownIndex !== 0) this.makeActive();
		if (this.dropdownIndex === 0 && newOptionList.length > 1) this.makeActive();
	}

	makeActive() {
		this.selectChoice.makeActive();
	}

	makeInactive() {
		this.selectChoice.makeInactive();
	}

	resetOptions() {
		this.selectChoice.clearStore();
		const emptyDropdownArr = [
			{
				value: this.element.dataset.placeholder,
				label: this.element.dataset.placeholder,
				selected: true,
				disabled: true,
			},
		];
		this.applyChoices(emptyDropdownArr);
	}

	disableDropdown() {
		this.selectChoice.disable();
	}

	enableDropdown() {
		this.selectChoice.enable();
	}

	findSelectedOption(event) {
		return parseInt(
			Array.from(event.currentTarget.options).find(option => option.selected)
				.value,
			10,
		);
	}

	optionPicked(event) {
		const previousValue = this.findSelectedOption(event);
		const newValue = event.detail.choice.value;

		if (previousValue !== newValue) {
			window.od.events.publish(Events.INKTONER_STORE_UPDATE, {
				payload: {
					assistedSearchIndex: this.assistedSearchIndex,
					changedDropdown: event.target.dataset.assistedsearchField,
					dropdownValue: {
						value: newValue,
						label: event.detail.choice.label,
						deviceUrl: event.detail.choice.customProperties.deviceUrl,
					},
				},
			});
		}
	}

	applyChoices(choiceList) {
		if (this.selectChoice) {
			this.selectChoice.initComponent.setChoices(
				choiceList,
				'value',
				'label',
				true,
			);
		} else {
			throw new Error('this.selectChoice not present on page');
		}
	}
}
